import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import Grid2 from '@mui/material/Unstable_Grid2';
import Section from '../../delivery-company-components/settings/section';
import NotificationFooter from './notification-footer';
import { useSnackBar } from '../../../contexts/snackbar';
import { IMerchantSettings } from '../../../interfaces/merchant/settings';
import NotificationManagerTemplates from '../../delivery-company-components/settings/notification-manager/notification-manager-templates';
import { MERCHANT_STAGES } from '../../delivery-company-components/settings/notification-manager/utils';
import { NotificationTemplateStatus } from '../../../enums/notifications';

function MerchantSettings() {
  const { config } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>();
  const [merchantSettings, setMerchantSettings] = useState<IMerchantSettings>({
    delivery_notification_footer: '',
    notification_template_status: NotificationTemplateStatus.UNDER_REVIEW,
    notification_templates: []
  });
  const { showMessage } = useSnackBar();

  useEffect(() => {
    const fetchMerchantSettings = async () => {
      try {
        const response = await axios.get<IMerchantSettings>(
          `${API_ENDPOINT}/api/v1/settings`,
          config
        );
        setMerchantSettings(response.data);

      } catch (e) {
        if (axios.isAxiosError(e)) {
          setError('Failed to load merchant settings: ' + e.message);
          showMessage('Failed to load merchant settings: ' + e.message, 'error');
        } else {
          setError('Failed to load merchant settings');
          showMessage('Failed to load merchant settings', 'error');
        }
        console.log(e);
      }

      setLoading(false);
    };

    fetchMerchantSettings();
  }, []);



  return (
    <div className="content-container">
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          Settings
        </Typography>

        {loading ? (
          <LinearProgress />
        ) : (
          <>
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <>
              <Grid2 spacing={2} container alignItems="stretch">
                <Grid2 xs={12} md={3}>
                  <Section title="Customer Notifications">
                    <NotificationManagerTemplates
                      notification_templates={merchantSettings.notification_templates}
                      singleTemplateMode={true}
                      stages={MERCHANT_STAGES}
                      notification_template_status={merchantSettings.notification_template_status}
                    />
                  </Section>

                </Grid2>
                <Grid2 xs={12} md={3} display="flex">
                  <Section title="Notification footer">
                    <NotificationFooter
                      value={merchantSettings.delivery_notification_footer ?? ''}
                      onSave={(newFooter) => setMerchantSettings(prev => ({
                        ...prev,
                        delivery_notification_footer: newFooter,
                      }))}
                    />
                  </Section>

                </Grid2>

              </Grid2>
          </>
          )}
      </>
      )}
    </Box>
</div>
);
}

export default MerchantSettings;
